<template>
  <div style="background-color:white">

    <el-row style="padding-top:10px">
      <el-col :span="24">
        <el-button class="btn" size="small" type="primary" v-if="show.sc" @click="handleCreate">上传合同</el-button>
        <el-form :inline="true" ref="deviceInfo" :model="deviceInfo" class="demo-form-inline"
          style="float:right!important">
          <el-form-item :label="lable.company">
            <el-select v-model="deviceInfo.company" filterable clearable :placeholder="'请选择' + lable.company"
              style="width:120px">
              <!-- <el-option v-for="item in statues" :key="item.value" :label="item.label" :value="item.value">
                </el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item :label="lable.signUser">
            <el-input v-model="deviceInfo.signUser" auto-complete="off" :placeholder="'请输入' + lable.signUser"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="getPurchaseContractClick">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-table :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }" ref="multipleTable" :data="tableData" tooltip-effect="dark"
          style="width: 100%;text-align: center" stripe>
          <el-table-column :label="lable.index" type="index" show-overflow-tooltip> <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template></el-table-column>

          <el-table-column prop="purchaseNumber" :label="lable.purchaseNumber" show-overflow-tooltip>
            <!-- <template slot-scope="scope" show-overflow-tooltip> -->
            <!-- <el-link :underline="false" @click="onClick(scope.row)" style="color: #4095E5;text-decoration: none;">
                {{ scope.row.purchaseNumber }}
              </el-link> -->
            <!-- </template> -->
          </el-table-column>
          <el-table-column prop="contractName" :label="lable.contractName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="contractNumber" :label="lable.contractNumber" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="signUser" :label="lable.signUser" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="company" :label="lable.company" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="createTime" :label="lable.createTime" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="path" :label="lable.path" v-if="false" show-overflow-tooltip>
          </el-table-column>
          <el-table-column :label="lable.cz" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button type="text" size="small" v-if="show.yl" @click="yulan(scope.row)">预览</el-button>
              <el-button type="text" size="small" v-if="show.xz" @click="downloading(scope.row)">下载</el-button>
              <el-button @click="cancel(scope.row)" v-if="show.zf" type="text" size="small">作废</el-button>

            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top:5px;height: 35px;">
        <el-pagination v-if="tableData.length > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
          :total="total" style="float:right">
        </el-pagination>
      </el-col>

    </el-row>
    <!------------------------------------------------------------------------- 上传合同-------------------------------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible" title="上传采购合同" :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="width:60% !important;margin-left: 300px;">
      <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="100px"
        style="width: 80%; margin-left:30px;">
        <el-form-item :label="lable.purchaseNumber">
          <el-select v-model="questionForm.purchaseNumber" filterable clearable style="width: 100%" placeholder="请选择采购单号">
            <el-option v-for="item in options" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="lable.contractName">
          <el-input :placeholder="'请输入' + lable.contractName" v-model="questionForm.contractName" />
        </el-form-item>
        <el-form-item :label="lable.contractNumber">
          <el-input :placeholder="'请输入' + lable.contractNumber" v-model="questionForm.contractNumber" />
        </el-form-item>
        <el-form-item :label="lable.signUser">
          <el-input :placeholder="'请输入' + lable.signUser" v-model="questionForm.signUser" />
        </el-form-item>
        <el-form-item :label="lable.company">
          <el-input :placeholder="'请输入' + lable.company" v-model="questionForm.company" />
        </el-form-item>
        <el-form-item :label="lable.createTime">
          <el-date-picker v-model="questionForm.createTime" style="width:100%" value-format="yyyy-MM-dd" width="100%"
            type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="合同附件">
          <el-upload class="upload" ref="upload" action="string" :file-list="fileList" :auto-upload="false"
            accept=".jpg,.npg,.png,.doc,.docx,.pdf,.xlsx" :http-request="uploadFile" :on-change="handleChange"
            :on-preview="handlePreview" :on-remove="handleRemove" multiple="multiple">
            <el-button slot="trigger" size="small" type="primary" @click="delFile">选取文件</el-button>
          </el-upload>
          <span>上传文件只能是jpg,png,npg,doc,docx,pdf,xlsx格式</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px;" size="small" v-preventReClick type="success"
          @click="submitUpload">上传</el-button>
        <el-button @click="dialogFormVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="previewTitle" :visible.sync="docxdialog" style="margin-top:-50px" width="63%">
      <FilePreview ref="filePreview" />
    </el-dialog>
  </div>
</template>

<script>
import {
  findAllPurchaseContract,
  contractUpload, delPurchaseContract, findAllCheckId, findByModule
} from "../../api/api";
import FilePreview from '../../components/preview/FilePreview.vue'

export default {
  name: "Contract",
  components: {
    "FilePreview": FilePreview,
  },
  data() {
    return {
      deviceInfo: {
        signUser: '',
        company: ''
      },
      show: {
        zf: false,
        sc: false,
        yl: false,
        xz: false
      },
      lable: {},
      options: [],
      //文件上传
      fileData: [],
      fileList: [],
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      tableData: [],
      multipleSelection: [],
      dialogFormVisible: false,
      questionForm: {},
      docxdialog: false,
      previewTitle: '',
    };
  },
  methods: {
    downloading(scop) {
      // debugger
      this.downloadUtil.downloadFile(scop.path, scop.contractName);
    },
    onClick(row) {
      this.questionForm = row;
      this.findByIdfile(row.id);
      this.dialogFormVisible = true;
    },
    yulan(row) {
      if (row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpg' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'png' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpeg') {
        this.previewTitle = "图片预览"
      } else {
        this.previewTitle = "文件预览"
      }
      this.docxdialog = true
      this.$nextTick(() => {
        this.$refs.filePreview.showView(row.path)
      })
    },
    handleCreate() {
      this.questionForm = {};
      this.$set(this.questionForm, `createTime`, this.timeUtil.timeFormat(new Date()))

      this.dialogFormVisible = true;
    },
    cancel(row) {
      this.$confirm('此操作将永久作废该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var userinfo = JSON.parse(localStorage.getItem("user"))

        var map = {
          id: row.id,
          userId: userinfo.userId
        }
        delPurchaseContract(map).then(datas => {
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error"
            });
          } else if (status == 200) {
            this.getPurchaseContract();
            this.$message({
              message: "作废成功",
              type: "success"
            });
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }
        });
      })
    },

    //合同文件上传
    submitUpload() {
      var userinfo = JSON.parse(localStorage.getItem("user"))

      let formData = new FormData();
      formData.append("file", this.fileList[0].raw); //拿到存在fileList的文件存放到formData中
      //下面数据是我自己设置的数据,可自行添加数据到formData(使用键值对方式存储)
      formData.append("purchaseNumber", this.questionForm.purchaseNumber == null ? "" : this.questionForm.purchaseNumber);
      formData.append("contractName", this.questionForm.contractName == null ? "" : this.questionForm.contractName);
      formData.append("contractNumber", this.questionForm.contractNumber == null ? "" : this.questionForm.contractNumber);
      formData.append("signUser", this.questionForm.signUser == null ? "" : this.questionForm.signUser);
      formData.append("company", this.questionForm.company == null ? "" : this.questionForm.company);
      formData.append("userId", userinfo.userId);
      formData.append("createTime", this.questionForm.createTime == null ? "" : this.questionForm.createTime);
      contractUpload(formData).then(datas => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.dialogFormVisible = false;
          this.getPurchaseContract();
          this.$message({
            message: "上传成功",
            type: "success"
          });
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
        this.fileList = [];
      });
    },
    //点击上传文件触发的额外事件,清空fileList
    delFile() {
      this.fileList = [];
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    //自定义上传文件
    uploadFile(file) {
      this.formData.append("file", file.file);
    },
    //删除文件
    handleRemove(file, fileList) {
    },
    // 点击文件
    handlePreview(file) {
    },
    getPurchaseContractClick(){
      this.pageIndex=1
      this.getPurchaseContract()
    },
    //查找资料信息
    getPurchaseContract() {
      let map = {
        company: this.deviceInfo.company,
        signUser: this.deviceInfo.signUser
      };
      findAllPurchaseContract(map).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          if (data == null) { this.data = [] } else { this.data = data; }

          this.tableData = this.data.slice(
            (this.pageIndex - 1) * this.pagesize,
            this.pageIndex * this.pagesize
          );
          this.total = data.length;
          // debugger
        }
      });
    },
    findAllId() {
      var userinfo = JSON.parse(localStorage.getItem("user"))

      findAllCheckId(userinfo.userId).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.options = data;
        }
      });
    },
    //分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.scrapData = this.data.slice((this.pageIndex - 1) * this.pagesize, this.pageIndex * this.pagesize)
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.scrapData = this.data.slice((this.pageIndex - 1) * this.pagesize, this.pageIndex * this.pagesize)
    },
    findLable() {
      findByModule("采购管理").then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    }
  },
  created() {
    this.findLable();

    this.findAllId();
    this.getPurchaseContract();
    var userinfo = JSON.parse(localStorage.getItem("user"))
    var arr = userinfo.role.menuId.split(",");
    arr.forEach((i) => {
      if (i == "66") {
        this.show.zf = true;
      }
      if (i == "67") {
        this.show.xz = true;
      }
      if (i == "68") {
        this.show.yl = true;
      }
      if (i == "128") {
        this.show.sc = true;
      }
    })
  },
};
</script>
<style >
.el-checkbox__inner {
    border: 1px solid #606266!important;
}
</style>
<style >
.el-input {
  width: 100%
}

.btn {
  float: left;
  margin-left: 5px;
}</style>



// WEBPACK FOOTER //
// src/views/purchase/Contract.vue